export default {
    nextPage(pageId) {
        return pageId + 1;
    },
    prevPage(pageId) {
        return pageId - 1;
    },
    isFirstPage(pageId) {
        return pageId === 1;
    },
    isLastPage(pageId, questionsLength) {
        return pageId === questionsLength;
    },
};
